import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import '../../HTMLIntro.css'; // Create this CSS file for additional styles

const HTMLIntro = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const courseSections = [
    {
      id: 'intro',
      title: 'Lesson One: What is HTML?',
      path: '/html-lesson-1',
      sublessons: [
        { title: 'How to Create Simple HTML Document', path: '/create-html' }
      ]
    },
    { id: 'tags', title: 'Lesson Two: HTML Tags', path: '/html-tags' },
    { id: 'paragraphs', title: 'Lesson Three: Paragraphs', path: '/html-paragraphs' },
    { id: 'line-breaks', title: 'Lesson Four: Line Breaks', path: '/html-line-break' },
    { id: 'headings', title: 'Lesson Five: Headings', path: '/html-headings' },
    { id: 'source-code', title: 'Lesson Six: View HTML Source Code', path: '/view-source-code' },
    { id: 'comments', title: 'Lesson Seven: Comments', path: '/html-comments' },
    { id: 'attributes', title: 'Lesson Eight: Attributes', path: '/html-attributes' },
    { id: 'id-selectors', title: 'Lesson Nine: id Selectors', path: '/id-selectors' },
    { id: 'class-selectors', title: 'Lesson Ten: Class Selectors', path: '/class-selectors' },
    { id: 'elements', title: 'Lesson Eleven: Block and Inline Elements', path: '/block-inline-elements' },
    { id: 'images', title: 'Lesson Twelve: Images', path: '/html-images' },
    { id: 'colors', title: 'Lesson Thirteen: Colors', path: '/html-colors' },
    { id: 'links', title: 'Lesson Fourteen: Links', path: '/html-links' },
    { id: 'quotes', title: 'Lesson Fifteen: Quotation and Citation Elements', path: '/html-quote' },
    { id: 'tables', title: 'Lesson Sixteen: Tables', path: '/html-tables' },
    { id: 'lists', title: 'Lesson Seventeen: Lists', path: '/html-lists' },
    { id: 'formatting', title: 'Lesson Eighteen: Text Formatting', path: '/html-text-format' }
  ];

  return (
    <HTMLCourseNavProvider>
      <div className="modern-course-container">
        <SideBar />
        
        <div className="course-content">
          <div className="course-header">
            <h1 className="course-title">HTML5 Course</h1>
            <p className="course-subtitle">Master the fundamentals of web development</p>
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '0%' }}></div>
              </div>
              <span className="progress-text">0% Complete</span>
            </div>
          </div>

          <div className="course-outline-card">
            <div className="card-header">
              <h2 className="card-title">
                <i className="fas fa-list-ol me-2"></i>
                Course Outline
              </h2>
              <span className="lesson-count">{courseSections.length} lessons</span>
            </div>

            <div className="lessons-container">
              {courseSections.map((section, index) => (
                <div key={section.id} className="lesson-section">
                  <div 
                    className={`lesson-item ${expandedSections[section.id] ? 'expanded' : ''}`}
                    onClick={() => section.sublessons && toggleSection(section.id)}
                  >
                    <div className="lesson-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    <div className="lesson-content">
                      <Link 
                        to={section.path} 
                        className="lesson-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {section.title}
                      </Link>
                      
                      {section.sublessons && (
                        <button className="expand-btn">
                          <i className={`fas fa-chevron-${expandedSections[section.id] ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                    </div>

                    <div className="lesson-status">
                      <span className="status-badge">Start</span>
                    </div>
                  </div>

                  {section.sublessons && expandedSections[section.id] && (
                    <div className="sublessons-container">
                      {section.sublessons.map((sublesson, subIndex) => (
                        <Link 
                          key={subIndex} 
                          to={sublesson.path} 
                          className="sublesson-item"
                        >
                          <div className="sublesson-number">
                            {index + 1}.{subIndex + 1}
                          </div>
                          <span className="sublesson-title">{sublesson.title}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="card-footer">
              <button className="start-course-btn">
                <i className="fas fa-play me-2"></i>
                Start Learning
              </button>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
};

export default HTMLIntro;